import { ActionButtonProps, Box, Form, LoaderNew, ModBox, Spacer } from '@jfs/ui-new'
import { useIsLargeScreen } from '@jfs/ui-new/src/utils/utils'
import { useRoute } from '@react-navigation/native'
import { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { ScrollView, ViewProps } from 'react-native'
import { useLazyApiData, useStores } from '../../../../data/store'
import { Routes } from '../../../../nav/routes'
import { isMobile, logEvent } from '../../../../util/util'
import { ItemState } from '../AddUser'
import { RenderActionButtons } from '../AddUser/ActionButton'
import { formData } from '../AddUser/FormData'
import { parseFormData } from '../AddUser/FormDataParser'
import { ModelUserAdded } from '../AddUser/ModelUserAdded'
import { Platform } from 'react-native'

const EditUser = ({ navigation }) => {
  const params = useRoute().params
  const { user }: any = params ?? {}
  const isEditScreen = user !== undefined
  // console.log('user', user, isEditScreen)
  const getJfsUserId = user?.id

  const {
    getPermissionList,
    mid,
    getMasterPermissionCheckboxData,
    masterDataList,
    getUserOptedPermissions,
    addEditUserApi,
    refreshUserManagementTable,
    refreshTable,
    merchants,
    selectedMid,
  } = useStores((store) => ({
    getPermissionList: store.userManagement.getUserPermissions,
    getUserOptedPermissions: store.userManagement.getUserOptedPermissions,
    mid: store.user.selectedMid,
    masterDataList: store.userManagement.masterPermissionList,
    getMasterPermissionCheckboxData: store.userManagement.getMasterPermissionCheckboxData,
    addEditUserApi: store.userManagement.addEditUserApi,
    refreshUserManagementTable: store.userManagement.refreshUserManagementTable,
    refreshTable: store.userManagement.refreshTable,
    selectedMid: store.user.selectedMid,
    merchants: store.user.merchants,
  }))

  const updateRealdOnlyData = (data, readOnly) => {
    // return data
    return data?.map((item) => {
      const updated = item?.data?.map((elem) => ({ ...elem, readOnly: readOnly }))
      return { ...item, data: updated }
    })
  }

  const [getUserPermissions, userPermissionHandler] = useLazyApiData(getPermissionList)
  const [getMasterPermissionApi, getMasterPermissionApiHandler] = useLazyApiData(getMasterPermissionCheckboxData)
  const previousData = updateRealdOnlyData(getUserOptedPermissions(undefined), true)
  const [accessRightsData, setAccessData] = useState(updateRealdOnlyData(getUserOptedPermissions(undefined), true))
  const [dropdownValue, updateDropdownValue] = useState(user?.department ?? 'Choose role')
  const [loading, setLoading] = useState(false)
  const [addEmailEnabled, setAddEmailEnabled] = useState(true)
  const [allEditable, setAllEditable] = useState(false)
  const [isCurrentFormValid, setIsCurrentFormValid] = useState(false)
  const { state } = userPermissionHandler
  const isLoading = state === 'pending' || loading === true || getMasterPermissionApiHandler.state === 'pending'
  const [showUserModel, setShowUserModel] = useState(false)
  const [addEditUser, addEditUserHandler = { data: [], state: undefined }] = useLazyApiData(addEditUserApi)

  useEffect(() => {
    if (addEditUserHandler.state === 'fulfilled') {
      setShowUserModel(true)
      //To update store for refreshing the table in previous screen, wont use state as it will lead to un necessary re render.
      refreshUserManagementTable(!refreshTable)
    }
    //NOTE: We don't need dependency of refreshTable because it will lead to re call of this use effect hook because store will change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addEditUserHandler.state, refreshUserManagementTable])

  const isAllChecked = (data: any) => {
    return (
      data.filter((item: any) => {
        return !item.isChecked
      }).length === 0
    )
  }

  const defaultCheckedArray: ItemState[] = accessRightsData?.map((item: any, index: number) => ({
    id: index,
    state: isAllChecked(item?.data) ? true : false,
    readOnly: true,
  }))

  const [checkedArray, setCheckedArray] = useState<ItemState[]>(defaultCheckedArray)
  const isLargeScreen = useIsLargeScreen()
  const isMob = isMobile(isLargeScreen)

  useLayoutEffect(() => {
    const postData = {
      jfsUserId: getJfsUserId,
      entityId: mid,
    }
    getUserPermissions(postData, isMob, true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getJfsUserId, getUserPermissions, mid])

  useEffect(() => {
    if (masterDataList === null) {
      getMasterPermissionApi()
    }
  }, [getMasterPermissionApi, masterDataList])

  const buttonRef = useRef<ActionButtonProps>()
  const formRef = useRef(null)

  const onDropdownValueChange = () => {
    const data = updateRealdOnlyData(accessRightsData, false)
    setAllEditable(isEditScreen)
    setAccessData(data)
  }
  const onSelectAllChange = () => {}

  const getFormData = (): any[] => {
    const initialFormData = [
      ...formData({
        dropdownValue: dropdownValue,
        onDropdownValueChange: onDropdownValueChange,
        accessRightsData: accessRightsData ?? [],
        isEditScreen: isEditScreen,
        onSelectAllChange: onSelectAllChange,
        expandView: false,
        checkedArray: checkedArray,
        updateCheckedArray: updateCheckedArray,
        allEditable,
        addEmailEnabled: addEmailEnabled,
        onPressAddEmail: setAddEmailEnabled,
      }),
    ]
    return initialFormData
  }

  const updateCheckedArray = (index: number, value: any) => {
    checkedArray[index].state = value
  }

  const actionButton = (props: ActionButtonProps) => {
    // console.log('values', props)
    // setFormValues(props)
    setIsCurrentFormValid(props.isCurrentFormValid)
    buttonRef.current = props
    return <></>
  }

  console.log('buttonRef?.current?.values', buttonRef?.current?.values)
  console.log('htag addEditUser ', addEditUserHandler)
  const onSubmitPress = () => {
    console.log('htag onSubmitPress ')
    const previousFormData = { ...user, accessRightsData: previousData ?? [] }
    const parsedData = parseFormData(buttonRef?.current?.values, previousFormData, isEditScreen, mid, getJfsUserId)
    logEvent('btn_press', isEditScreen ? 'edit_user' : 'add_user')
    addEditUser(isEditScreen, parsedData)
  }

  const navigateUser = () => {
    setShowUserModel(false)
    if (Platform.OS === 'android')
    {
        navigation?.popTo(Routes.USER_MANAGEMENT.VIEW_USERS)
    }
    else
    {
        // navigation?.goBack()
        navigation?.popTo(Routes.USER_MANAGEMENT.VIEW_USERS)
    }
  }

  return (
    <Box flex={1} backgroundColor="SECONDARY">
      <ScrollView
        style={styles.listWrapper}
        contentContainerStyle={{ justifyContent: 'space-between', flexDirection: 'column' }}
        showsVerticalScrollIndicator={false}>
        <ModBox show={isLoading} f={1} justify={'center'}>
          <LoaderNew />
        </ModBox>
        <ModBox show={!isLoading} position="relative">
          <Form
            ref={formRef}
            container={Container}
            formData={getFormData()}
            actionButtons={actionButton}
            initialValues={{
              userName: user?.name ?? '',
              mobile: user?.mobileNo ?? '',
              email: user?.email ?? '',
              role: user?.department ?? '',
            }}
          />
          <Spacer size={50} direction="vertical" />
        </ModBox>
      </ScrollView>
      <ModBox bg={'WHITE'} pv={15} ph={25}>
        <RenderActionButtons
          buttonRef={buttonRef}
          isEditScreen={isEditScreen}
          addEmailEnabled={addEmailEnabled}
          isCurrentFormValid={isCurrentFormValid}
          mid={mid}
          jfsUserId={getJfsUserId}
          previousFormData={{ ...user, accessRightsData: previousData ?? [] }}
          screenName={Routes.USER_MANAGEMENT.VIEW_USERS}
          borderTopColor={'TRANSPARENT'}
          navigation={navigation}
          onSubmitPress={onSubmitPress}
          isLoading={addEditUserHandler?.state === 'pending'}
        />
      </ModBox>
      <ModelUserAdded
        title={isEditScreen ? 'User updated successfully' : 'User added successfully'}
        description={
          isEditScreen
            ? 'We have updatd user information for the mobile number'
            : 'User can now login to the Jio Business and access transactions with the permission you have provided'
        }
        show={showUserModel}
        data={buttonRef?.current?.values}
        onDismiss={() => setShowUserModel(false)}
        onPressDone={navigateUser}
      />
    </Box>
  )
}

const Container = ({ children }) => <Box width={'100%'}>{children}</Box>

const styles = {
  listWrapper: {
    backgroundColor: '#fff',
    padding: 25,
    paddingTop: 35,
    borderTopLeftRadius: 30,
    borderTopRightRadius: 30,
    width: '100%',
    height: '100%',
    marginTop: 70,
    zIndex: 4,
    //overflow: 'auto',
  } as ViewProps,
}
export default EditUser
